import { Directive, effect, HostBinding, HostListener, inject, input, signal } from '@angular/core';
import { BreakpointObserverService, buildSrcSetBySizeMap, IMAGE_SRC_SET_SIZE_MAP, SIZES } from '@core';

@Directive({
  selector: 'img[imgFallback]',
  standalone: true,
  host: {
    '[sizes]': 'sizes',
    '(error)': 'onError()',
    '[src]': 'currentSrc()',
    '[srcset]': 'currentSrcSet()',
  },
})
export class ImageFallbackDirective {
  isMobile = inject(BreakpointObserverService).isMobile;
  isTablet = inject(BreakpointObserverService).isTablet;
  readonly sizeMap = IMAGE_SRC_SET_SIZE_MAP;
  readonly sizes = SIZES;

  fallbackSrc = input('assets/images/others/default-fallback-image.png');
  inputSrcSet = input<string[] | null>(null);
  inputSrc = input<string | null>(null);

  protected currentSrcSet = signal<string | null>(null);
  protected currentSrc = signal<string | null>(this.inputSrc());

  constructor() {
    effect(() => {
      let srcSet = '';
      if (this.inputSrcSet()?.length) {
        if (this.isMobile()) {
          srcSet = buildSrcSetBySizeMap(this.inputSrcSet() as string[], { mobile: this.sizeMap.mobile });
        } else if (this.isTablet()) {
          srcSet = buildSrcSetBySizeMap(this.inputSrcSet() as string[], { medium: this.sizeMap.medium });
        } else {
          srcSet = buildSrcSetBySizeMap(this.inputSrcSet() as string[], { big: this.sizeMap.big });
        }
      }
      this.currentSrcSet.set(srcSet);
      this.currentSrc.set(this.inputSrc() ?? '');
    });
  }

  onError(): void {
    this.currentSrcSet.set(this.fallbackSrc());
    this.currentSrc.set(this.fallbackSrc());
  }
}
